import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import img from '../../assets/course/image-1.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { Helmet } from 'react-helmet'
library.add(fas, fab)

const Sadakshari = () => {
  return (
    <div>
                <Helmet>
                  		<title>Mr.Sadakshari | Takshila VLSI</title>
                        <meta name="description" content="Meet Sadakshari, an experienced VLSI trainer at Takshila VLSI, dedicated to guiding students toward success in semiconductor and VLSI design." />
                        <link rel="canonical" href="https://www.takshila-vlsi.com/teachers/sadakshari/" />
                        <meta property="og:locale" content="en_US" />
                        <meta property="og:type" content="article" />
                        <meta property="og:title" content="Mr.Sadakshari | Takshila VLSI" />
                        <meta property="og:description" content="Meet Sadakshari, an experienced VLSI trainer at Takshila VLSI, dedicated to guiding students toward success in semiconductor and VLSI design." />
                        <meta property="og:url" content="https://www.takshila-vlsi.com/teachers/sadakshari/" />
                        <meta property="og:site_name" content="Takshila VLSI" />
                        <meta property="article:modified_time" content="2024-11-28T13:05:50+00:00" />
                        <meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2018/12/1920px-EPROM_Microchip_SuperMacro.jpg" />
                        <meta property="og:image:width" content="1920" />
                        <meta property="og:image:height" content="1278" />
                        <meta property="og:image:type" content="image/jpeg" />
                        <meta name="twitter:card" content="summary_large_image" />
                  </Helmet>
                <Header/>
                <main>
                    <section className='section-banner ws-section pg-banner mb-5'>
                            <div class="container">
                                <div class="row justify-content-around ">
                                    <div class="col-lg-6">
                                        <div class="img-radius mb-4">
                                            <img src={img} alt=''/>
                                        </div>
                                        
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="icon_left">
                                                    <div class="step-card bg-linear radius-1 mb-4 d-flex p-3 dark-bg"><div class="step"><FontAwesomeIcon icon="fa-solid fa-location-dot" /></div>
                                                <div class="step-content">
                                                    <h5 class="step-card-head mb-2">Postal Address:</h5>
                                                    <p>2nd Floor, Ram Arcade, 90/1B, CKB Layout,<br/>
                                                    Chandra Layout, Marathahalli, <br/>
                                                    Bengaluru, Karnataka 560037, INDIA</p>
                                                    </div></div>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="icon_left">
                                                    <div class="step-card bg-linear radius-1 mb-4 d-flex p-3 dark-bg">
                                                        <div class="step"><FontAwesomeIcon icon="fa-solid fa-phone" /></div>
                                                <div class="step-content">
                                                    <h5 class="step-card-head mb-2">Phone:</h5>
                                                    <p><a href="tel:+8 (800) 659-2684">+91 97429 72744</a></p>
                                                    </div></div>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="icon_left">
                                                    <div class="step-card bg-linear radius-1 mb-4 d-flex p-3 dark-bg">
                                                        <div class="step"><FontAwesomeIcon icon="fa-solid fa-envelope" /></div>
                                                <div class="step-content">
                                                    <h5 class="step-card-head mb-2">Email:</h5>
                                                    <p><a href="mailto:peterparker_im_spider_man@masterstudy.com">info@takshila-vlsi.com</a></p>
                                                    </div></div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="pg-title-sec p-3">
                                            <h2 className='pg-title pb-3'>About Mr. Sadakshari</h2>
                                            <p>Mr. Sadakshari has around 12+ years of rich experience in Analog Layout. He worked with major Tier -1 semiconductor product and service companies such as Texas Instruments, Rambus, Tata Elxsi. He worked on several top products like PCIe, APLL and SerDes. We believe his experience and knowledge shape our students as next level engineers for this industry.</p>
                                        </div>
                                        <div class="pg-wrapper wpb_tabs p-3">
                                            <nav>
                                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                                <button class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Skills</button>
                                                <button class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Biography</button>
                                                <button class="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">Send message</button>
                                                
                                            </div>
                                            </nav>
                                            <div class="tab-content" id="nav-tabContent">
                                            <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab" tabindex="0">
                                                <div class="wpb_wrapper p-5">
                                                                <p><strong>Expertise Areas:</strong></p>
                                                    <ul>
                                                    <li>AMS IP layout design.</li>
                                                    <li>Memory layout design.</li>
                                                    <li>Module based floorplanning techniques.</li>
                                                    <li>Full chip / Block integration.</li>
                                                    <li>Physical verification (LVS, DRC, ERC, Antenna fix, soft checks, stress &amp; CLDRC).</li>
                                                    <li>Signal integrity / Cross talk and Static IR drop analysis.</li>
                                                    </ul>

                                                            </div>
                                            </div>
                                            <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab" tabindex="0">
                                                <div class="wpb_wrapper p-5">
                                                    <p>Mr. Sadakshari has around 12+ years of rich experience in Analog Layout. He worked with major Tier -1 semiconductor product and service companies such as Texas Instruments, Rambus, Tata Elxsi. He worked on several top products like PCIe, APLL and SerDes. We believe his experience and knowledge shape our students as next level engineers for this industry.</p>
                                                    </div>
                                            </div>
                                            <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab" tabindex="0">
                                                <div class="wpb_wrapper p-5">
                                                     <iframe
                                                    aria-label='Register Now'
                                                    width="100%"
                                                    height="850"
                                                    src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                                    frameborder="0" 
                                                    title='Register Now'
                                                
                                                />
                                                </div>
                                               
                                            </div>
                                            
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </section>
                </main>
                <Footer/>
        </div>
  )
}

export default Sadakshari